import styled, { css } from 'vue-styled-components';

import { DropdownTrigger as CommonDropdownTrigger } from '@/components/Common/Dropdown';

import {
    FLEX_COLUMN_DIV,
    FLEX_VERTICAL_CENTER_DIV,
} from '@/styles/common.styled.component';

export const DropdownWrapper = styled.div`
    width: 100%;
    height: 100%;
`;

export const DropdownTrigger = styled(CommonDropdownTrigger)`
    width: 306px;

    &.ant-dropdown-open {
        border-color: var(--color-blue-60);
    }

    &.disabled {
        cursor: not-allowed;
        &:hover {
            background: var(--color-gray-white);
        }
    }
`;

export const OverlayContainer = styled(FLEX_COLUMN_DIV)`
    width: 320px;

    max-height: 300px;
    padding: 8px;
    overflow-y: auto;

    border-radius: 8px;
    border: 1px solid var(--color-gray-40);
    background: var(--color-gray-white);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    &:has(.ghost) * {
        cursor: grabbing !important;
    }
`;

const rowProps = { selected: Boolean };

export const Label = styled.span`
    flex: 1;
    color: var(--color-gray-90);
    font-size: 13px;
    font-weight: 400;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const iconStyle = css`
    width: 16px;
    height: 16px;
    flex-shrink: 0;
`;

export const Row = styled(FLEX_VERTICAL_CENTER_DIV, rowProps)`
    height: 32px;
    padding: 0px 8px;
    gap: 8px;
    flex-shrink: 0;
    border-radius: 4px;
    user-select: none;

    svg {
        ${iconStyle}

        &.check-icon {
            fill: none;
        }
    }

    &:hover {
        background: var(--color-gray-10);
    }

    ${({ selected }) =>
        selected &&
        css`
            span {
                color: var(--color-blue-60);
                font-weight: 600;
            }

            svg.check-icon {
                fill: var(--color-blue-70);
            }
        `}
`;

// 영역 1: 드래그 전용
export const DragHandle = styled(FLEX_VERTICAL_CENTER_DIV)`
    flex-shrink: 0;
    width: 16px;
    height: 100%;
    cursor: grab;

    svg {
        * {
            fill: var(--color-gray-110);
        }
    }
`;

// 영역 2: 클릭 + 드래그
export const ClickArea = styled(FLEX_VERTICAL_CENTER_DIV)`
    flex: 1;
    height: 100%;
    gap: 8px;
    cursor: pointer;
    overflow: hidden;
`;

// 영역 3: 삭제 전용
export const DeleteButton = styled(FLEX_VERTICAL_CENTER_DIV)`
    flex-shrink: 0;
    width: 16px;
    height: 100%;
    cursor: pointer;

    svg {
        padding: 2px;
        fill: var(--color-gray-80);
    }
`;
